<template>
   <div>
      <v-container>
         <v-row class="pt-3">
            <v-toolbar dense :color="this.$globalstore.secondary_titleclass" bottom>
               <v-toolbar-title> Edit User </v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn color="indigo" class="white ma-2" outlined @click="SaveUser">
                  Save
               </v-btn>
               <v-btn color="indigo" class="white ma-2" outlined @click="goBack()">
                  Back
               </v-btn>
            </v-toolbar>
         </v-row>

         <v-form ref="userform" v-model="userform_valid">
            <v-row class="pt-2">
               <v-col cols="12" md="8">
                  <v-card flat outlined class="px-2">
                     <v-text-field label="User Name" v-model="edit_user_name" required>
                     </v-text-field>
                     <v-text-field label="Email" v-model="edit_user_email" required> </v-text-field>
                  </v-card>
               </v-col>
               <v-col cols="12" md="4">
                  <v-card flat outlined class="px-2">
                     <v-select
                        label="User Type"
                        :items="$globalstore.usertype_select"
                        item-text="text"
                        item-value="id"
                        return-object
                        v-model="edit_user_type"
                        required
                     ></v-select>

                     <v-select
                        label="Status"
                        :items="$globalstore.status_select"
                        item-text="text"
                        item-value="id"
                        return-object
                        v-model="edit_user_status"
                        required
                     >
                     </v-select>
                  </v-card>
               </v-col>
            </v-row>
         </v-form>
         <v-row align="start">
            <v-col cols="12" md="3">
               <v-btn color="primary" @click="showPasswordForm">Change Password</v-btn>
            </v-col>
         </v-row>
         <v-row>
            <v-col cols="12" md="4">
               <v-card flat outlined class="pa-2">
                  <label class="mr-2">Created:</label>{{ user_createdate }}
               </v-card>
            </v-col>
            <v-col cols="12" md="4">
               <v-card flat outlined class="pa-2">
                  <label class="mr-2">Last Login:</label>{{ user_lastlogin }}
               </v-card>
            </v-col>

            <v-col cols="12" md="4">
               <v-card flat outlined class="pa-2">
                  <label class="mr-2">Link ID:</label>{{ user_linkid }}
               </v-card>
            </v-col>
         </v-row>

         <v-row class="py-1">
            <v-col cols="12" md="6">
               <v-row>
                  <v-col cols="12">
                     <v-card flat outlined class="px-2">
                        <div class="py-2">
                           <b>Roles</b>
                           <v-btn x-small fab class="primary ml-4" @click="addRole">
                              <v-icon>mdi-plus</v-icon>
                           </v-btn>
                           <v-btn x-small fab class="primary ml-2" @click="removeRole">
                              <v-icon>mdi-minus</v-icon>
                           </v-btn>
                        </div>
                     </v-card>
                  </v-col>
               </v-row>
               <v-card flat outlined class="px-2">
                  <v-data-table
                     dense
                     :headers="roletable_headers"
                     hide-default-header
                     hide-default-footer
                     item-key="role_id"
                     :items="userroledata"
                     @click:row="userRoleRowClick"
                     single-select
                  >
                  </v-data-table>
               </v-card>
            </v-col>

            <v-col cols="12" md="6">
               <v-row>
                  <v-col cols="12">
                     <v-card flat outlined class="px-2">
                        <div class="py-3">
                           <b>Capabilities</b>
                        </div>
                     </v-card>
                  </v-col>
               </v-row>
               <v-card flat outlined>
                  <v-data-table
                     dense
                     :headers="captable_headers"
                     hide-default-header
                     hide-default-footer
                     :items="rolecaplist"
                     item-key="cap_id"
                     single-select
                     @click:row="captableRowClick"
                  >
                  </v-data-table>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
      <change-password ref="changepassword" @input="onPasswordChange"></change-password>
      <role-list
         :roledata="userroledata"
         :dialogvisible.sync="roledlg"
         @save-selection="onRoleSelect"
         @cancel-selection="roledlg = false"
      ></role-list>
      <confirm-dlg ref="confirm"></confirm-dlg>
      <show-toast ref="toast"></show-toast>
   </div>
</template>

<script>
   import RoleList from "@/components/RoleList.vue";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ChangePassword from "@/components/ChangePassword.vue";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {RoleList, ConfirmDlg, ChangePassword, ShowToast},

      data() {
         return {
            edit_userid: -1,
            edit_user_name: "",
            edit_user_email: "",
            edit_user_status: null,
            edit_user_type: null,
            edit_user_role: null,
            user_lastlogin: "",
            user_tokenexpiry: "",
            user_createdate: "",
            user_modifydate: "",
            user_linkid: "",
            userform_valid: true,
            roletable_headers: [
               {text: "Role", value: "role_name"},
               {text: "Description", value: "role_description"},
            ],
            captable_headers: [
               {text: "ID", value: "cap_id"},
               {text: "Capability", value: "cap_name"},
            ],
            rolelist: [],
            rolecaplist: [],
            userroledata: [],
            userrole_index: -1,
            roledlg: false,
            roleselected: null,
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },

         showPasswordForm() {
            this.$refs.changepassword.open();
         },

         async onPasswordChange(credential) {
            await this.$http({
               url: "/common/updatepassword.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  id: this.edit_userid,
                  credential: credential,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.ShowMessage({title: "Error", message: response.data.message, color: "red"});
               } else {
                  this.$refs.toast.display({
                     message: response.data.message,
                     color: this.$globalstore.toast_successclass,
                  });
               }
            });
         },

         async addRole() {
            this.roledlg = true;
         },

         async doRemoveRole(item) {
            await this.$http({
               url: "/common/removeuserrole.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  id: this.edit_userid,
                  role_id: item.role_id,
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  let index = this.userroledata.findIndex((x) => x.role_id == item.role_id);

                  if (index !== -1) {
                     this.userroledata.splice(index, 1);
                     this.userrole_index = -1;
                     this.rolecaplist = [];
                  }
               }
            });
         },

         // Remove role assigned to user
         async removeRole() {
            if (this.userrole_index > -1) {
               let item = this.userroledata[this.userrole_index];

               await this.$refs.confirm
                  .open("Delete Role", "Are you sure you want to delete " + item.role_name + "?", {
                     color: "orange",
                  })
                  .then((reply) => {
                     if (reply) {
                        this.doRemoveRole(item);
                     }
                  });
            }
         },

         userRoleRowClick(item, row) {
            row.select(true);
            this.userrole_index = row.index;
            this.rolecaplist = item.rolecaplist;
         },

         async doSaveRole(item) {
            await this.$http({
               url: "/common/saveuserrole.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  id: this.edit_userid,
                  role_id: item.role_id,
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.userroledata.push(item);
               }
            });
         },

         onRoleSelect(item) {
            this.roledlg = false;
            if (!this.userroledata.some((x) => x.role_id == item.role_id)) {
               this.doSaveRole(item);
            }
         },

         captableRowClick(item, row) {
            row.select(true);
         },

         SaveUser() {
            if (this.$refs.userform.validate()) {
               this.doSaveUser();
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
            }
         },

         async doSaveUser() {
            await this.$http({
               url: "/common/updateuser.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  id: this.edit_userid,
                  useremail: this.edit_user_email,
                  username: this.edit_user_name,
                  userstatus: this.edit_user_status.id,
                  usertype: this.edit_user_type.id,
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.goBack();
               } else {
                  this.ShowMessage({
                     title: "Error",
                     message: response.data.message,
                     color: "red",
                  });
               }
            });
         },

         async loadRoleList() {
            await this.$http({
               url: "/common/getrolelist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.rolelist = response.data.rolelist;
               } else {
                  this.ShowMessage({title: "Error", message: response.data.message, color: "red"});
               }
            });
         },
         async getUserByID() {
            await this.$http({
               url: "/common/getuser_byid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {id: this.edit_userid},
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  let user = response.data.userdata;
                  this.edit_user_name = user.username;
                  this.edit_user_email = user.useremail;
                  this.edit_user_status = this.$globalstore.status_select.find(
                     (item) => item.id === user.userstatus
                  );
                  this.edit_user_type = this.$globalstore.usertype_select.find(
                     (item) => item.id === user.usertype
                  );
                  this.user_createdate = user.createdate;
                  this.user_modifydate = user.modifydate;
                  this.user_lastlogin = user.lastlogin;
                  this.user_linkid = user.userlinkid;
                  this.user_tokenexpiry = user.tokenexpiry;

                  if (user.userroles) {
                     this.userroledata = user.userroles;
                  }
               } else {
                  this.ShowMessage({title: "Error", message: response.data.message, color: "red"});
               }
            });
         },
      },
      mounted() {
         if (this.$route.params.userid) {
            this.edit_userid = this.$route.params.userid;
            this.loadRoleList();
            this.getUserByID();
         }
      },
   };
</script>
